module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_demo_mie_off-991af8f140c32b9de3b96165a48a04f4.png";